import { Modal } from 'antd';
import styled from 'styled-components';

export default styled(Modal)`
  width: 550px;

  .ant-modal-content {
    height: 250px;
  }

  .ant-modal-close {
    display: none;
  }
`;
